import { render, staticRenderFns } from "./CommentActions.vue?vue&type=template&id=0bbf3ea8&"
import script from "./CommentActions.vue?vue&type=script&lang=js&"
export * from "./CommentActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports